import { VUFile } from 'vue-upload-component';
import { Mutation, Action } from 'vuex-module-decorators';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { EdgePatientEnrollmentApi } from '@trialcard/apigateway.client/edgePatientEnrollmentApi';
import {
    EnterpriseCoordinatorSharedAddressUpsearchModel,
    EnterpriseCoordinatorSharedEmailAddressUpsearchModel,
    EnterpriseCoordinatorSharedPhoneUpsearchModel,
    EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel,
    UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel,
    UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel,

} from '@trialcard/apigateway.models';
import { Gender, RoleType } from '@trialcard/enums';
import { AxiosResponse , AxiosError, AxiosInstance, AxiosRequestConfig, AxiosPromise } from 'axios';
import { DocumentV3Api, EdgeEnrollmentApi, EdgeDocumentsApi } from '@trialcard/apigateway.client';
import { union, unionBy } from 'lodash';
import moment, { Moment } from 'moment';
import { Settings } from '~/services/settings';
import SurveyModule from '~/store/survey';
import { rolling365 } from '~/tests/e2e/@data/shared/dates';
import { pharmacyMN } from '~/tests/e2e/@data/shared/memberNumbers';
import { DocumentFunctions } from '~/components/DocumentUpload/document-functions';



@InjectModule({ stateFactory: true }, module)
export default class EnrollmentModule extends InjectVuexModule {
    @Resolve
    public patientEnrollmentApi!: EdgePatientEnrollmentApi;

    @Resolve
    public enrollmentApi!: EdgeEnrollmentApi;

    @Resolve
    public settings!: Settings;

    @Resolve
    public survey!: SurveyModule;

    @Resolve
    public documentFunctions!: DocumentFunctions;

    @Resolve
    public documentV3Api!: DocumentV3Api;

    @Resolve
    documentApi!: EdgeDocumentsApi;

    isCareGiver: boolean | null = null;

    enrollmentTypeBiOrQuickBi = '';

    patientNeeds= '' as string;
    moreInsuranceData = {
        pAsubmitted: "",
        pAapproved: "",
        pAapprovalDates:"",
        referenceNumber:"",
        pursuingAppeal:"",
        noInsurance:false,
        subscriberId: "",
        memberId:""

    }
    defaultDiagnosisInformation = {
        growthHormone1: false,
        growthHormone2: false,
        growthHormone3: false,
        growthHormone4: false,
        idiopathicShortStature: false,
        smallGestational: false,
        newbornAffected: false,
        newbornSmall: false,
        p05: false,
        turnerSyndrome9: false,
        turnerSyndrome8: false,
        turnerSyndrome4: false,
        turnerSyndrome3: false,
        turnerSyndrome2: false,
        turnerSyndrome1: false,
        turnerSyndrome0: false,
        praderWilliSyndrome: false,
        adultGrowthHormone: false,
        otherDiagnosis: false,

        p05TextField: '',
        otherDiagnosisTextField: '',

    }

    defaultPatientInformationData = {
        firstName: '' as string,
        lastName: '' as string,
        dateOfBirth: null as Moment | null,
        addresses: [] as EnterpriseCoordinatorSharedAddressUpsearchModel[],
        emailAddresses: [] as EnterpriseCoordinatorSharedEmailAddressUpsearchModel[],
        phoneNumbers: [] as EnterpriseCoordinatorSharedPhoneUpsearchModel[],
        gender: null as Gender | null,
    };


    defaultCareGiverPageData = {
        contactName:"",
        relationshipToPatient:"",
        primaryPhone:"",
        preferredTime:"",
        dayCheckBox:false,
        nightCheckBox:false,
    }
    careGiverPageData =  this.defaultCareGiverPageData ;
    public defaultassessmentData ={
        medicalRecord: false as boolean,
        mriResults: false as boolean,
        historyAndPhysical: false as boolean,
        growthChart: false as boolean,
        growthTestDate: false as boolean,
        IGFDate: false as boolean,
        otherResults: false as boolean,

        futureDate1:  null as Moment | null,
        Agent1: '',
        Peak1: '',
        Agent2: '',
        Peak2: '',
        futureDate2: null as Moment | null,
        IGFResults: '',
        Test1: '',
        Result1: '',
        Test2: '',
        Result2: '',
    }


    public defaultAuthorizationData ={
        concentCheckbox: false as boolean,
        presFirstName: '',
        presPractice: '',
        zip: '',
        DEANumber: '',
        presAddress: '',
        city: '',
        state: '',
        officeContact: '',
        phone: '',
        email:'',
        fax: '',
        taxID: '',
        npi: '',
        direction: '',
        firstName: '',
        lastName: '',
        ifDispense:false,
        signDate: moment().format('L')
    }

    public defaultQiAuthorizationData = {
        presFirstName: '',
        phone: '',
        fax: '',
        npi: '',
        presPractice:'',
        concentCheckbox: false as boolean,
        firstName: '',
        lastName: '',
        ifDispense:false,
        signDate: moment().format('L')
    }
    pharmacyInsuranceData = {
        PharmacyInsuranceCarrier:"",
        PharmacyPolicyHolderName:"",
        PharmacyPolicyNumber:"",
        subscriberId:"",
        memberId:""
     }
    defaultPharmacyInsuranceData = {
        PharmacyInsuranceCarrier:"",
        PharmacyPolicyHolderName:"",
        PharmacyPolicyNumber:"",
        subscriberId:"",
        memberId:""
     }
    defaultMoreInsuranceData = {
        pAsubmitted: "",
        pAapproved: "",
        pAapprovalDates:"",
        referenceNumber:"",
        pursuingAppeal:"",
        noInsurance:false,
        subscriberId: "",
        memberId: ""

    }
    public defaultassessment2Data ={
        currentHeight: '',
        currentHeightPerc: '',
        motherHeight: '',
        fathersHeight: '',
        adultHeight: '',
        currentWeight: '',
        birthWeight: '',
        growthVelocity: '',
        year: '',
        month: '',
        date: null as Moment | null,
        chronologicalYear: '',
        chronologicalMonth: '',
        chronologicalDate: null as Moment | null,
        selectAssessment: '',
    }

    defaultCareGiverInformationData = {
        firstName: '' as string,
        lastName: '' as string,
        addresses: [] as EnterpriseCoordinatorSharedAddressUpsearchModel[],
        emailAddresses: [] as EnterpriseCoordinatorSharedEmailAddressUpsearchModel[],
        phoneNumbers: [] as EnterpriseCoordinatorSharedPhoneUpsearchModel[],
    };

    defaultOtherInformation = {
        primaryLanguage:  '' as string,
    };

    defaultPrescriberData = [
        {
            model: {
                firstName: '',
                lastName: '',
                npi: '',
                accountRelationshipIsPrimary: true,
                prescriberLicenses: [],
                externalIds: [],
                addresses: [],
                phoneNumbers: [],
                emailAddresses: [],
            },
        },
    ] as UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel[];

    defaultSiteData = [
        {
            model: {
                accountRelationshipIsPrimary: true,
                siteRoleType: RoleType.PrescriberSite,
                pointOfContacts: [],
                description: '',
                addresses: [
                    {
                        addressOne: '',
                        addressTwo: '',
                        zip: '',
                        city: '',
                        state: '',
                    },
                ],
                contacts: [],
                emailAddresses: [],
                externalIds: [],
                phoneNumbers: [],
                globalIds: [],
            },
        },
    ] as UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel[];

    defaultPayorData = [
        {
            model: {
                payorId: (null as unknown) as number,
                payorType: (null as unknown) as number,
                accountRelationshipIsPrimary: true,
                payorGroup: '',
                payorName: '',
                webAddresses: [],
                addresses: [] as any [],
                phoneNumbers: [
                    {
                        phoneType: 1,
                        phoneNumber: '',
                        phonePurpose: 1,
                    },
                    {
                        phoneType: 3,
                        phoneNumber: '',
                        phonePurpose: 8,
                    },
                ],
                emailAddresses: [],
                contacts: [],
                payorBenefit: {
                    dateOfBirth: null as Moment | null,
                    policyHolderFirstName: '',
                    policyHolderLastName: '',
                    relationshipToPatient: undefined,
                    policyNumber: '',
                    planType: undefined,
                },
            },
        },
    ]  ;

    public defaultServicesData ={
        omnitropeSelfPay: false as boolean,
        quickBenefitsInvestigation:  false as boolean,
        paAssistance: false as boolean,
        interimDrug: false as boolean,
        injectionTraining: false as boolean,
        copaySavingsProgram: false as boolean,
        patientStarterKit: false as boolean,
        fullBI: false as boolean,
        preferredTrainer: "" as string
    }

    defaultContactPreferences = [] as EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel[];

    defaultPatientIsData = {
        patientIs: '',
        otherBrand: '',
    };

    defaultPharmacyInsurance = {
        PharmacyState: '',
        PharmacyInsuranceCarrier: '',
        PharmacyPolicyHolderName: '',
        PharmacyPolicyNumber: '',
        PharmacyGroupNumber: '',
        PharmacyPhone: ''
    }

    defaultPrescriptionData = {
        omnitrope5mgCartridgeChkbox: false,
        omnitrope10mgCartridgeChkbox: false,
        omnitropePen5ChkBox: false,
        omnitropePen10ChkBox: false,
        omnitropeVialChkBox: false,
        BDPen29GaugeChkBox: false,
        BDPen31GaugeChkBox: false,
        BDPen31Gauge8mmChkBox: false,
        BDPenOtherChkBox: false,
        BDPenAncillaryChkBox: false,
        BDPenOtherTxt: '',
        BDPenAncillaryTxt: '',
        SyringeMixingChkBox: false,
        SyringeDosingChkBox: false,
        Syringe29GaugeChkBox: false,
        Syringe31GaugeChkBox: false,
        Syringe31Gauge8mmChkBox: false,
        SyringeOtherChkBox: false,
        SyringeAncillaryChkBox: false,
        SyringeOtherTxt: '',
        SyringeAncillaryTxt: '',
        DeviceDoseMgTxt: '',
        DeviceDoseDaysTxt: '',
        DeviceDispenseTxt: '',
        DeviceRefillsTxt: '',
        VialDoseMlTxt: '',
        VialDoseDaysTxt: '',
        VialDispenseTxt: '',
        VialRefillsTxt: '',
        PreferredPharmacyTxt: '',
        docsForUpload: [] as VUFile[],
    };

    defaultPatientSecondaryInsuranceData = {
        patientSecondaryInsurance: '',
    }

    defaultMemberNumber = pharmacyMN.number

    defaultExpirationDate = rolling365;

    memberNumber = this.defaultMemberNumber;
    expirationDate = this.defaultExpirationDate;
    patientInformationData = { ...this.defaultPatientInformationData };
    careGiverInformationData = { ...this.defaultCareGiverInformationData };
    prescriberData = [...this.defaultPrescriberData];
    siteData = [...this.defaultSiteData];
    payorData = [...this.defaultPayorData];
    otherData = { ...this.defaultOtherInformation };
    contactPreferences = [...this.defaultContactPreferences];
    patientIsData = { ...this.defaultPatientIsData};
    diagnosisInformtion= {...this.defaultDiagnosisInformation};
    assessmentData = {...this.defaultassessmentData};
    assessment2Data = {...this.defaultassessment2Data};
    patientSecondaryInsuranceData = { ...this.defaultPatientSecondaryInsuranceData };
    servicesData = {...this.defaultServicesData};
    secondaryMedicalPayorData = {...this.defaultPayorData};
    prescriptionData = { ...this.defaultPrescriptionData };

    AuthorizationData={...this.defaultAuthorizationData};
    qiAuthorizationData = {...this.defaultQiAuthorizationData}
    pharmacyPayorData = {...this.defaultPayorData};

    public docsForUpload: VUFile[] = [];
    public docsForUploadtemp:VUFile[] = [];

    @Mutation
    public async updatePatientInformation(newPatientInformation: typeof EnrollmentModule.prototype.patientInformationData) {
        this.patientInformationData = { ...this.patientInformationData, ...newPatientInformation };
    }
    @Mutation
    public async updateCareGiverPageData(newData: typeof EnrollmentModule.prototype.defaultCareGiverPageData) {
        this.careGiverPageData = newData;
    }


    @Mutation
    public async updatePrescribers(newPrescriberData: UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel[]) {
        this.prescriberData = [...newPrescriberData];
    }

    @Mutation
    public async updateSites(newSites: UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel[]) {
        this.siteData = [...newSites];
    }

    @Mutation
    updatemoreInsuranceData(newdata: typeof EnrollmentModule.prototype.moreInsuranceData){
        this.moreInsuranceData = newdata
    }
    @Mutation
    public async updatePayors(newPayorData: any[]) {
        this.payorData = [...newPayorData];
    }
// secodary Medical insurance
    @Mutation
    public async updateSecodaryMedicalPayors(newSecondaryPayorData: any[]) {
        this.secondaryMedicalPayorData = [...newSecondaryPayorData];
    }

    @Mutation
    public async updatePharmacyPayors(newPharmacyPayorData:any[]) {
        this.pharmacyPayorData = [...newPharmacyPayorData];
    }

    @Mutation
    public async updateCareGiverInformation(newCareGiverInformation: typeof EnrollmentModule.prototype.careGiverInformationData) {
        this.patientInformationData = { ...this.patientInformationData, ...newCareGiverInformation };
    }

    @Mutation
    public async updateContactPreferences(newContactPreferences: EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel[]) {
        this.contactPreferences = [...newContactPreferences];
    }

    @Mutation
    public async updateOtherInformation(newOtherInfo: any) {
        this.otherData = { ...newOtherInfo };
    }
    @Mutation
    public async updatePharmacyInsuranceData(newpharmacyInsuranceData: typeof EnrollmentModule.prototype.pharmacyInsuranceData){
        this.pharmacyInsuranceData = newpharmacyInsuranceData
    }
    @Mutation
    public setMemberNumber(memberNumber: string) {
        this.memberNumber = memberNumber;
    }

    @Mutation
    public setExpirationDate(expirationDate: Moment) {
        this.expirationDate = expirationDate;
    }

    @Mutation
    public setTypeBiOrQuickBi(alternative: string) {
        this.enrollmentTypeBiOrQuickBi = alternative;
        localStorage.setItem('enrollmentTypeBiOrQuickBi', alternative)
    }

    @Mutation
    public setIsCaregiver(isCareGiver: boolean | null) {
        this.isCareGiver = isCareGiver;
    }
    // patient Needs
    @Mutation
    public updatePatientNeeds(newPatientNeeds: string) {
        this.patientNeeds = newPatientNeeds;
    }

// Diagnosis information
    @Mutation
    public updateDiagnosisInformation(newDiagnosisInformation: any){
        this.diagnosisInformtion = newDiagnosisInformation;
    }
// -------------------------------------------------------------


    @Mutation
    public async updatePatientIsObject(newPatientIsData: typeof EnrollmentModule.prototype.patientIsData) {
        this.patientIsData = { ...this.patientIsData, ...newPatientIsData };
    }

    @Mutation
    updatePDFassessmentData(newassessmentData: typeof EnrollmentModule.prototype.defaultassessmentData) {
        this.assessmentData = { ...newassessmentData };
    }

    @Mutation
    updateAuthorizationData(newAuthorizationData: typeof EnrollmentModule.prototype.defaultAuthorizationData) {
        this.AuthorizationData = { ...newAuthorizationData };
    }


    @Mutation
    updateQiAuthorizationData(newAuthorizationData: typeof EnrollmentModule.prototype.defaultQiAuthorizationData) {
         this.qiAuthorizationData = {...newAuthorizationData}
    }

    @Mutation
    updatePDFassessment2Data(newassessment2Data: typeof EnrollmentModule.prototype.defaultassessment2Data) {
        this.assessment2Data = { ...newassessment2Data };
    }

    @Mutation
    updatePDFservicesData(newServiceData: typeof EnrollmentModule.prototype.defaultServicesData) {
        this.servicesData = { ...newServiceData };
    }

    @Mutation
    public async updatePatientSecondaryInsuranceObject(newPatientSecondaryInsuranceData: typeof EnrollmentModule.prototype.patientSecondaryInsuranceData) {
        this.patientSecondaryInsuranceData = { ...this.patientSecondaryInsuranceData, ...newPatientSecondaryInsuranceData };
    }

    @Mutation
    public async updatePrescriptionObject(newPrescriptionData: typeof EnrollmentModule.prototype.prescriptionData) {
        this.prescriptionData = { ...this.prescriptionData, ...newPrescriptionData };
    }

    @Mutation
    public addSMNForm(data: any) {
        // this.receipts.files.push(data as any)
        this.docsForUpload=[];
        this.docsForUpload[0] = data;
    }

    @Mutation
    public addPrescriptionPDF() {
        // this.receipts.files.push(data as any)
        this.prescriptionData.docsForUpload.forEach(file => {
            this.docsForUpload.push(file);

        });
    }
//
    @Mutation
    public updateDocsForUpload(data: typeof EnrollmentModule.prototype.docsForUpload) {
        this.docsForUpload = union(this.docsForUpload, data);
    }

    @Mutation
    public clearDocsForUpload() {
        this.docsForUpload = [] as VUFile[];
    }

    @Action({ rawError: true })
    public clearStore() {
        this.setMemberNumber(this.defaultMemberNumber);
        this.setExpirationDate(this.defaultExpirationDate);
        this.updatePatientInformation(this.defaultPatientInformationData);
        this.updateCareGiverInformation(this.defaultCareGiverInformationData);
        this.updatePrescribers(this.defaultPrescriberData);
        this.updateSites(this.defaultSiteData);
        this.updatePayors(this.defaultPayorData);
        this.updateContactPreferences(this.defaultContactPreferences);
        this.updatePatientIsObject(this.defaultPatientIsData);
        this.updateOtherInformation(this.defaultOtherInformation);
        this.updatePDFassessmentData(this.defaultassessmentData);
        this.updatePatientSecondaryInsuranceObject(this.defaultPatientSecondaryInsuranceData);
        this.updatePrescriptionObject(this.defaultPrescriptionData);
        this.clearDocsForUpload();
        this.updateSecodaryMedicalPayors(this.defaultPayorData);
        this.updatePharmacyPayors(this.defaultPayorData);
        this.updatePatientNeeds('');
        this.updateDiagnosisInformation(this.defaultDiagnosisInformation);
        this.updateAuthorizationData(this.defaultAuthorizationData);
        this.updateQiAuthorizationData(this.defaultQiAuthorizationData);
        this.updatePDFassessment2Data(this.defaultassessment2Data);
        this.updatePDFservicesData(this.defaultServicesData);
        this.updatemoreInsuranceData(this.defaultMoreInsuranceData);
        this.updateCareGiverPageData(this.defaultCareGiverPageData)
        this.updatePharmacyInsuranceData(this.defaultPharmacyInsuranceData)
    }

    @Action({ rawError: true })
    public clearEnrollment() {
        this.updatePatientInformation({ ...this.defaultPatientInformationData });
        this.setMemberNumber(this.defaultMemberNumber);
    }


   async uploadDocument(request: {  documentTypeId: string | null }): Promise<{
    success: boolean;
    data:{};
    messages: string[];
}> {
    const files: Array<{ files: File[]; }> = [];
    // To create a PDF file
    const mergedFileByteArray = await this.documentFunctions.mergeFiles(this.docsForUpload)
    const fileBlob = new Blob([mergedFileByteArray.buffer], { type: 'applicaton/pdf'})
    const file = new File([fileBlob], 'smn.pdf', { type: 'application/pdf', lastModified: Date.now() })
    const mergedPdf = { file }

    files.push({ files: [mergedPdf.file] })

    const uploadDocumentResponse = {
        success: true,
        data:{},
        messages: [] as string[],
    };
    try {
        if (files.length > 0) {
            const submitClaimResponses = await Promise.all(
                files.map(async f => {
                    const form = new FormData();
                    if (request.documentTypeId) form.append('type', request.documentTypeId);
                    f.files.map(async x => {
                        form.append('attachment', x);
                    });
                    form.append('externalPartyCode',"CLS");
                    form.append('externalProgramCode',"OMNI");
                    const axios: AxiosInstance = (this.documentApi as any).axios;
                    const axiosRequest: AxiosRequestConfig = {
                        url: 'edge/documents/v1/Document/upload',
                        method: 'POST',
                        data: form,
                        headers: {
                            'x-program-id': this.settings.programId,
                        },
                    };
                    await Promise.all([
                        (this.documentApi as any).authentications.Token.applyToRequest(axiosRequest),
                    ]);
                    return axios.request(axiosRequest);
                })
            );
            for (const response of submitClaimResponses) {
                if (!response.data.success) {
                    uploadDocumentResponse.success = false;
                    uploadDocumentResponse.messages.push(...response.data.messages!);
                } else {
                    uploadDocumentResponse.data = response.data.data!;
                }
            }
        }
        return uploadDocumentResponse;
    } catch (error) {
        // log error
        console.log(error)
        return uploadDocumentResponse;
    }
    }
}
